export default function () {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25" fill="none">
            <path d="M12.5 19.3428V12.5928" stroke="url(#paint0_linear_1135_3358)" strokeLinecap="round" />
            <path d="M12.5 12.5928L9.5 15.5928" stroke="#D9AA68" strokeLinecap="round" />
            <path d="M12.5 12.5928L15.5 15.5928" stroke="#D9AA68" strokeLinecap="round" />
            <path
                d="M5.75051 8.41521L16.0633 4.22349C16.579 4.01391 17.1665 4.26568 17.3704 4.78359L18.8 8.41521M21.5 11.1585V9.41521C21.5 8.86292 21.0523 8.41521 20.5 8.41521H4.5C3.94772 8.41521 3.5 8.86292 3.5 9.41521V11.1585C4.84949 11.1585 6.2 12.0725 6.2 13.9017C6.2 15.7309 4.85051 16.645 3.5 16.645V18.3882C3.5 18.9405 3.94772 19.3882 4.5 19.3882H20.5C21.0523 19.3882 21.5 18.9405 21.5 18.3882V16.645C20.1505 16.645 18.8 15.2728 18.8 13.6727C18.8 12.0725 20.1505 11.1585 21.5 11.1585Z"
                stroke="url(#paint1_linear_1135_3358)"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <defs>
                <linearGradient id="paint0_linear_1135_3358" x1="13" y1="16.3428" x2="13" y2="20.0928" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#D9AA68" />
                    <stop offset="1" stopColor="#C38B49" />
                </linearGradient>
                <linearGradient id="paint1_linear_1135_3358" x1="21.5" y1="8.34277" x2="13" y2="19.3428" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#FBD997" />
                    <stop offset="0.736154" stopColor="#CC9856" />
                    <stop offset="1" stopColor="#C28A48" />
                </linearGradient>
            </defs>
        </svg>
    );
}
